
module dg.objects {

    angular.module('dg.objects').component('gridCellLayout', {
        bindings: {
            propertyId: '@',
            options: '<?'
        },  
        require: {
            ObjectDisplayerController: '^objectDisplayer'
        },
        controller: DisplayLayoutController,
        templateUrl: '/digmo/src/objects/properties/layouts/grid-cell-layout.html'
    });
}